import { apiConfig } from '../config/api.config';
import { callAPI } from './apiUtilities';

export const getUserProfileAPI = () =>
  callAPI(`${apiConfig.hazardsRootUrl}/user`, {
    method: 'get',
  });

export default { getUserProfileAPI };
